import AuthorizationRequest from './AuthorizationRequest';

export default AuthorizationRequest;
